"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapPatientInformationToPatientGroupData = void 0;
const models_1 = require("@home-health-notify/models");
const locationHelper_1 = require("./locationHelper");
const mapPatientInformationToPatientGroupData = (patientInformation, currentData, googleMapApiKey, mrn) => __awaiter(void 0, void 0, void 0, function* () {
    const { diagnosis, physician, caregiver, pharmacy, address } = patientInformation;
    const diagnosisText = [
        (diagnosis === null || diagnosis === void 0 ? void 0 : diagnosis.primaryDiagnosis) &&
            `Primary Dx: ${diagnosis.primaryDiagnosis.longDescription}`,
        (diagnosis === null || diagnosis === void 0 ? void 0 : diagnosis.secondaryDiagnosis) &&
            `Secondary Dx: ${diagnosis.secondaryDiagnosis.longDescription}`,
    ]
        .filter(Boolean)
        .join("\n");
    const createInfoDetail = (contact) => (contact === null || contact === void 0 ? void 0 : contact.name) && (contact === null || contact === void 0 ? void 0 : contact.phone)
        ? [
            {
                name: contact.name,
                countryCode: "+1",
                phoneNo: contact.phone,
                sortOrder: models_1.SortOrder.PRIMARY,
            },
        ]
        : undefined;
    const info = Object.assign(Object.assign(Object.assign(Object.assign({}, currentData.info), (createInfoDetail(physician) && {
        physician: createInfoDetail(physician),
    })), (createInfoDetail(caregiver) && {
        careGiver: createInfoDetail(caregiver),
    })), (createInfoDetail(pharmacy) && {
        pharmacy: createInfoDetail(pharmacy),
    }));
    let resolvedAddress = currentData.address;
    if (address) {
        const placeName = [
            address.address,
            address.city,
            address.state,
            address.zip,
        ]
            .filter(Boolean)
            .join(", ");
        // Address geocoding is best-effort enrichment: if it fails (missing Google
        // Maps key, network error, etc.) keep the unresolved address and still
        // populate the rest of the patient fields rather than failing the sync.
        try {
            const result = yield (0, locationHelper_1.searchAddress)(placeName, googleMapApiKey);
            if (result.length > 0) {
                resolvedAddress = Object.assign(Object.assign({}, resolvedAddress), { apartmentNo: result[0].parsedAddress.subpremise, lat: result[0].location.lat, lng: result[0].location.lng, placeName: result[0].formattedAddress });
            }
        }
        catch (_a) {
            // Keep resolvedAddress as the unresolved currentData.address.
        }
    }
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, currentData), (mrn && { mrn })), (patientInformation.firstName && {
        firstName: patientInformation.firstName,
    })), (patientInformation.lastName && {
        lastName: patientInformation.lastName,
    })), (patientInformation.dateOfBirth && {
        dob: patientInformation.dateOfBirth,
    })), (patientInformation.insurance && {
        insurance: patientInformation.insurance.policyProvider,
    })), (patientInformation.phone && { phoneNo: patientInformation.phone })), (diagnosisText && { about: diagnosisText })), { info, address: resolvedAddress });
});
exports.mapPatientInformationToPatientGroupData = mapPatientInformationToPatientGroupData;
